// JsFromRoutes CacheKey ff051d31843da01dfe9238c20a2fc33c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/invitations/:token'),
  accept: /* #__PURE__ */ definePathHelper('post', '/invitations/:token/accept'),
  startSignup: /* #__PURE__ */ definePathHelper('post', '/invitations/:token/start-signup'),
  resend: /* #__PURE__ */ definePathHelper('post', '/:account_id/invitations/:id/resend'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/invitations'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/invitations/:id'),
}
